/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useRef } from "react";
import initProductSavedCartsSelector from "components/jiffy/product-saved-carts-selector/product-saved-carts-selector";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import "./DtfConfirmationModal.scss";

function DtfConfirmationModal({ children, slots, onClose, onSubmit, ...restProps }) {
  const [closed, setClosed] = useState(false);
  const closedRef = useRef(false);
  const modalRef = useRef(null);

  function hasSubmit() {
    return slots?.button;
  }

  function handleClose() {
    closedRef.current = true;
    setClosed(true);
    $(modalRef.current).modal("hide");
    onClose?.();
  }

  function handleSubmit() {
    closedRef.current = true;
    setClosed(true);
    const $modal = $(modalRef.current);
    $modal.one("hidden.bs.modal", () => {
      onSubmit?.();
    });
    $modal.modal("hide");
  }

  function handleShow() {
    const $modal = $(modalRef.current);
    $modal.modal("show").on("hidden.bs.modal", () => {
      $modal.off("hidden.bs.modal");
      if (!closedRef.current) {
        onClose?.();
      }
    });
  }

  useEffect(() => {
    handleShow();
    initProductSavedCartsSelector(true);
  }, []);

  return (
    <div
      {...restProps}
      className="modal dtf-confirmation-modal scope-cfd4d835"
      ref={modalRef}
      role="dialog"
      data-testid="modal"
    >
      <div className="dtf-confirmation-modal__modal-box modal-dialog scope-cfd4d835">
        <div
          className="dtf-confirmation-modal__modal-header scope-cfd4d835"
          role="heading"
          aria-label="Confirm action"
          tabIndex="0"
          data-testid="dtf-confirmation-modal-modal-header"
        >
          <h3 className="dtf-confirmation-modal__modal-title scope-cfd4d835">
            {slots?.header?.()}
          </h3>
          <button
            className="dtf-confirmation-modal__modal-button-close scope-cfd4d835"
            type="button"
            onClick={handleClose}
            data-testid="dtf-confirmation-modal-modal-button-close"
          >
            <UseSvg className="scope-cfd4d835" icon="modal-close-big" data-testid="use-svg" />
          </button>
        </div>
        <div className="dtf-confirmation-modal__modal-body scope-cfd4d835">
          <div className="dtf-confirmation-modal__text scope-cfd4d835">{slots?.text?.()}</div>
          <div className="dtf-confirmation-modal__actions scope-cfd4d835">
            {hasSubmit() ? (
              <button
                className="dtf-confirmation-modal__submit scope-cfd4d835"
                type="button"
                onClick={handleSubmit}
                data-testid="dtf-confirmation-modal-submit"
              >
                {slots?.button?.()}
              </button>
            ) : null}
            <button
              className="dtf-confirmation-modal__cancel scope-cfd4d835"
              type="button"
              onClick={handleClose}
              data-testid="dtf-confirmation-modal-cancel"
            >
              {slots?.cancel?.() ?? <>Cancel</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DtfConfirmationModal;
